var React = require('react');

function FlagGermany (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.5 0H0.5V15H25.5V0Z","fill":"black","key":0}),React.createElement("path",{"d":"M25.5 5H0.5V15H25.5V5Z","fill":"#DD0000","key":1}),React.createElement("path",{"d":"M25.5 10H0.5V15H25.5V10Z","fill":"#FFCE00","key":2})]);
}

FlagGermany.defaultProps = {"width":"26","height":"15","viewBox":"0 0 26 15","fill":"none"};

module.exports = FlagGermany;

FlagGermany.default = FlagGermany;
